import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import Dropdown from 'flarum/common/components/Dropdown';
import IssueListItem from './IssueListItem';
import InfoTile from 'flarum/common/components/InfoTile';
export default class IssueList extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "filters", {
      state: {
        options: ['all', 'closed', 'open']
      }
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    let loadingMore = m(LoadingIndicator, null);
    if (!this.attrs.state.isLoadingNext()) {
      loadingMore = m(Button, {
        className: "Button",
        onclick: () => this.attrs.state.loadNext()
      }, app.translator.trans('sycho-github-milestone.forum.load_more'));
    }
    if (!this.attrs.state.hasNext() && !this.attrs.state.isLoadingNext()) loadingMore = '';
    const issuesVnodes = [];
    this.attrs.state.getAllItems().forEach(issue => {
      issuesVnodes.push(m("li", null, m(IssueListItem, {
        issue: issue
      })));
    });
    return m("div", {
      className: "GithubMilestone-issues"
    }, m("div", {
      className: "IndexPage-toolbar"
    }, m("ul", {
      className: "IndexPage-toolbar-view"
    }, listItems(this.viewItems().toArray())), m("ul", {
      className: "IndexPage-toolbar-action"
    }, listItems(this.actionItems().toArray()))), this.attrs.state.isLoading() ? m(LoadingIndicator, null) : m("div", {
      className: "GithubMilestone-issuesContainer DiscussionList DiscussionList--floatingTags"
    }, issuesVnodes.length > 0 ? m("ul", {
      className: "GithubMilestone-issuesList DiscussionList-discussions"
    }, issuesVnodes) : m(InfoTile, {
      icon: "fas fa-check"
    }, app.translator.trans('sycho-github-milestone.forum.empty_list')), m("div", {
      className: "DiscussionList-loadMore"
    }, loadingMore)));
  }
  changeState(state) {
    this.attrs.activeState(state);
    this.attrs.state.refreshParams({
      filter: {
        state
      }
    }, 1);
  }
  viewItems() {
    const items = new ItemList();
    items.add('state', m(Dropdown, {
      buttonClassName: "Button",
      label: app.translator.trans("sycho-github-milestone.forum.".concat(this.attrs.activeState()))
    }, this.filters.state.options.map(state => {
      const active = state === this.attrs.activeState();
      return m(Button, {
        icon: active ? 'fas fa-check' : ' ',
        onclick: this.changeState.bind(this, state),
        active: active
      }, app.translator.trans("sycho-github-milestone.forum.".concat(state)));
    })));
    return items;
  }
  actionItems() {
    const items = new ItemList();

    //

    return items;
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/components/IssueList', IssueList);